// src/views/cancel.js
import React from "react";
import "./cancel.css";
import "./common-view.css";
import { useTranslation } from "react-i18next";

const Cancel = () => {
  const { t } = useTranslation();

  return (
    <div className="cancel-page">
      <div className="cancel-card">
        <div className="cancel-icon-badge">⚠️</div>

        <h1 className="cancel-title">
          {t("cancel.title", "Payment Cancelled")}
        </h1>
        <p className="cancel-subtitle">
          {t(
            "cancel.subtitle",
            "No worries — no charges were made and you can try again whenever you’re ready."
          )}
        </p>

        <div className="cancel-box">
          <p className="cancel-small">
            {t("cancel.mistakeTitle", "If you cancelled by mistake:")}
          </p>
          <ul className="cancel-list">
            <li>{t("cancel.step1", "Return to your preferred plan")}</li>
            <li>{t("cancel.step2", "Review your subscription options")}</li>
            <li>{t("cancel.step3", "Complete secure Stripe checkout")}</li>
          </ul>
        </div>

        <div className="cancel-actions">
          <a className="btn-cancel-primary" href="/dashboard?tab=onboarding">
            {t("cancel.tryAgain", "Try Again")} →
          </a>
          <a className="btn-cancel-secondary" href="/">
            <span className="btn-back-icon">←</span>
            <span>{t("commonLabel.backToHome", "Back to Home")}</span>
          </a>
        </div>

        <p className="cancel-footnote">
          {t(
            "cancel.footnote",
            "Need assistance? Reply directly in WhatsApp or reach out to our team."
          )}
        </p>
      </div>
    </div>
  );
};

export default Cancel;